import { create_card_record, get_card_by_id, query_card_record_list } from '@/api/mjstore-model';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-cardrecord-config';
import column_config from '@/components/page-model/mjstore/mjstore-cardrecord-column-config';

import { reactive } from 'vue';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
  const { baseColumns, newSlotList } = column_config(current_org);

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '购卡日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择购卡日期',
      },
      // {
      //   type: 'remotemodal',
      //   name: 'delete_staff_id',
      //   label: '撤卡执行人',
      //   disabled: false,
      //   placeholder: '请选择撤卡执行人',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-staff',
      // },
      {
        type: 'input',
        name: 'order_code',
        label: '卡号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写卡号',
      },
      {
        type: 'input',
        name: 'card_name',
        label: '卡名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写卡名称',
      },
      {
        type: 'select',
        name: 'is_now_num',
        label: '执行情况',
        disabled: false,
        placeholder: '请选择执行情况',
        mode: 'default',
        allowClear: true,
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      customer_id: null,
      staff_id: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      is_now_num: true,
      is_delete: false,
      delete_staff_id: null,
    }),
  };
  const search_options = {
    is_delete: [
      { value: None, name: '全部' },
      { value: True, name: '已撤卡' },
      { value: False, name: '未撤卡' },
    ],
    is_now_num: [
      { value: true, label: '待执行' },
      { value: false, label: '执行完' },
    ],
  };

  // const is_disable_dict = ref({ 'total_num': false });
  const edit_model_config = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'card_id',
        label: '卡名称',
        disabled: false,
        placeholder: '请选择卡名称',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-card',
      },
      {
        type: 'number',
        name: 'total_num',
        label: '卡次数',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写卡次数',
      },
      {
        type: 'number',
        name: 'single_price',
        label: '单价',
        disabled: true,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写单价',
      },
      {
        type: 'number',
        name: 'price',
        label: '卡金额',
        disabled: true,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写卡金额',
      },
      {
        type: 'number',
        name: 'czje',
        label: '充值使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写充值使用金额',
      },
      {
        type: 'number',
        name: 'flje',
        label: '返利使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写返利使用金额',
      },
      {
        type: 'number',
        name: 'zjfl',
        label: '直接返利',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写直接返利',
      },
      {
        type: 'number',
        name: 'zjje',
        label: '赠券使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写赠券使用金额',
      },
      {
        type: 'datepicker',
        name: 'date',
        label: '购卡日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD HH:mm:ss',
        valueFormat: 'YYYY-MM-DD HH:mm:ss',
        showTime: true,
        placeholder: '请选择购卡日期',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      {
        type: 'remotemodal',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'input',
        name: 'mark',
        label: '备注',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写备注',
      },
    ],
    rules: {
      customer_id: [{ required: true, message: '请填输入会员姓名' }],
      card_id: [{ required: true, message: '请填输入卡名称' }],
      date: [{ required: true, message: '请填输入下单时间' }],
      shop_id: [{ required: true, message: '请填输入执行门店' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      customer_id: null,
      card_id: null,
      total_num: null,
      single_price: null,
      price: null,
      czje: null,
      flje: null,
      zjfl: null,
      zjje: null,
      date: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      staff_id: null,
    }),
    watch: {
      single_price: (data: any) => {
        data.price = data.single_price * data.total_num;
      },
      total_num: (data: any) => {
        data.price = data.single_price * data.total_num;
      },
      card_id: (data: any, form: any) => {
        if (data['card_id'] > 0) {
          get_card_by_id({
            org_id: current_org.id,
            card_id: Number(data.card_id),
          }).then((res: any) => {
            if (res) {
              // is_disable_total_num.value = true;
              data.single_price = res.price;

              const f = form.fields.find((item: any) => {
                return item.name == 'total_num';
              });
              if (f) {
                data.total_num = 1;
                f.disabled = res.card_type == 11;
              }
            }
          });
        }
      },
    },
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '卡购买记录管理',
    addModalTitle: '新建卡购买记录',
    updateTitle: '修改卡购买记录',
    del_btn: '作废',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_card_record_list,
    addData: create_card_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
